// DemoCard.tsx
import { timeToComplete } from "../utils";
import { Card, Image, Text } from "@mantine/core";

interface DemoCardProps {
  demoLink: string;
  demoTitle: string;
  demoTime?: string; // Made optional
  demoImage?: string; // Made optional
}

const DemoCard = ({
  demoLink,
  demoTitle,
  demoTime,
  demoImage,
}: DemoCardProps): JSX.Element => {
  return (
    <Card
      shadow="sm"
      padding="xl"
      component="a"
      href={demoLink}
      target="_blank"
      radius="lg"
      className="demo-card"
    >
      {demoImage && (
        <Card.Section className="demo-card-image-section">
          <Image
            src={demoImage}
            alt={demoTitle}
            fit="cover"
            className="demo-card-image"
          />
        </Card.Section>
      )}

      <Text fw={500} size="lg" mt="md" className="demo-card-title">
        {demoTitle}
      </Text>

      {demoTime && (
        <Text size="sm" c="dimmed" className="demo-card-time">
          {timeToComplete(demoTime)}
        </Text>
      )}
    </Card>
  );
};

export default DemoCard;
